import { createContext, SetStateAction, Dispatch } from "react";

import { FormInstance } from "antd";

import { GetCommertialsConditionsResponse, HomeQuotationComponent, HomeQuotationRequest, WebHomeQuotation } from "../../../../../../../../../shared/interfaces";
import { QuotationButton } from "../../../../../shared";
import { CoveragePlanSelected } from "../../../../interfaces/listPlansSelected";

import { CoveragePerPlanId, HomePaymentMethodForm, HomeQuotationForm } from "./StepThreeFormProvider";

interface StepThreeFormContextProps {
    stepThreeHomeQuotationForm:             FormInstance<HomeQuotationForm>;
    homePaymentMethodsForm:                 FormInstance<HomePaymentMethodForm>;
    stepThreeHomeQuotationFormCoverages:    FormInstance<any>;
    stepThreeHomeQuotationFormSummary:      FormInstance<any>;

    isLoadingForm:                          boolean;
    setIsLoadingForm:                       Dispatch<SetStateAction<boolean>>;

    labelButton:                            QuotationButton;
    setLabelButton:                         Dispatch<SetStateAction<QuotationButton>>;

    quotationResponse?:                     any | undefined;
    setQuotationResponse:                   Dispatch<SetStateAction<any | undefined>>;

    quotationResponseClosed:                 Array<{ planSelected: string, response: WebHomeQuotation }>;

    planSelectedSummary:                    string;
    setPlanSelectedSummary:                 Dispatch<SetStateAction<string>>

    listPlansSelected:                      CoveragePlanSelected[];
    setListPlansSelected:                   any;   

    commertialConditions:                   GetCommertialsConditionsResponse | undefined;
    clearPrimaFieldsOnFormChange:           () => void;

    generateHomeQuotationForm:              () => HomeQuotationRequest;
    generateHomeQuotationFormByPlan:        any;

    homeQuotationComponents:                Array<HomeQuotationComponent>;

    canGetCoveragesPerPlanByTab:            CoveragePerPlanId | undefined;
    setCanGetCoveragesPerPlanByTab:         Dispatch<SetStateAction<CoveragePerPlanId | undefined>>;

    handlerOnClickQuotation:                (form: HomeQuotationRequest) => Promise<void>;
    updateFieldsBeforeQuotation:            (components: any) => void;

    handlerOnClick:                         () => Promise<void>;

    quotationTabs:                          Array<any>;
    activeTab:                              any;
    handlePressTab:                         (activeTab: string) => void;

    executeQuotationForSelectedClosePlan:   () => Promise<void>;

    resetAllFormFields:                     () => void;

    createTabs:                             () => void;
}

export const StepThreeFormContext = createContext({} as StepThreeFormContextProps);